import api from '../api/axios';

export const STRAPI_BASE_URL = (process.env.REACT_APP_API_URL || 'https://darb.aiastra.io').replace(/\/$/, '');

export function resolveStrapiMediaUrl(url: string): string {
  if (!url || typeof url !== 'string') return url;
  const trimmed = url.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (trimmed.startsWith('/')) return `${STRAPI_BASE_URL}${trimmed}`;
  return trimmed;
}

/** Make inline images load in the admin editor (Strapi returns /uploads/... paths). */
export function absolutizeContentHtml(html: string): string {
  if (!html) return html;
  return html.replace(
    /(<img[^>]*\ssrc=["'])(\/uploads\/[^"']+)(["'])/gi,
    (_, pre, path, post) => `${pre}${STRAPI_BASE_URL}${path}${post}`,
  );
}

/** Store portable paths so the public site can prefix its own Strapi URL. */
export function relativizeContentHtml(html: string): string {
  if (!html) return html;
  const escaped = STRAPI_BASE_URL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return html.replace(
    new RegExp(`(<img[^>]*\\ssrc=["'])${escaped}(/uploads\\/[^"']+)(["'])`, 'gi'),
    (_, pre, path, post) => `${pre}${path}${post}`,
  );
}

export async function uploadStrapiFile(file: File): Promise<{ id: number; url: string } | null> {
  const formData = new FormData();
  formData.append('files', file);
  try {
    const response = await api.post('/upload', formData);
    const fileData = response.data?.[0];
    if (!fileData?.url) return null;
    const relative = fileData.url.startsWith('/') ? fileData.url : `/${fileData.url}`;
    return { id: fileData.id, url: relative };
  } catch {
    return null;
  }
}
